/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsNegative } from '../../factoriesAny.js';
export var isNegativeDependencies = {
  typedDependencies: typedDependencies,
  createIsNegative: createIsNegative
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsNegative.generated.js
// module id = 132
// module chunks = 0